export default "__VITE_ASSET__C$vEiowM__"